import React from "react";
import menuConfig from "../configurations/menuConfig";
import QuickLinks from "./dashboard/Quicklinks";

const NotFound = (...props) => (
  <div className="container">
    <div className="row notfound-wrapper" id="notfound">
      <div className="col-xs-12">
        <div className="notfound text-center">
          <h1>404</h1>
          <h2>Oops! This page does not exist</h2>
          <hr />
          <div className="row quick-links">
            {menuConfig.menus.map(menu => (
              <QuickLinks location={props.location} menu={menu} allowedPermissions={menu.permissions} key={menu.key} />
            ))}
        </div>
        </div>
      </div>
    </div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/notFound.js